<template>
<div style="height: 100%;width: 100%">
  <el-container  style="height: 100%;width: 100%">
    <el-header height="15%" class="border" style="padding: 5px">
      <el-form-item>
        <el-select v-model="thing" filterable clearable placeholder="物件名称">
          <el-option v-for="item in things" :key="item.id" :label="item.label" :value="item.id"></el-option>
        </el-select>
        <el-select v-model="building" filterable clearable placeholder="楼棟">
          <el-option v-for="item in buildings" :key="item.id" :label="item.label" :value="item.id"></el-option>
        </el-select>
        <el-select v-model="floor" filterable clearable placeholder="楼层">
          <el-option v-for="item in floors" :key="item.id" :label="item.label" :value="item.id"></el-option>
        </el-select>
        <el-date-picker v-model="day" format="YYYY 年 M 月" value-format="YYYY-M-1" type="month"
                        @change="changeMonth(day)" placeholder="请选择月份"/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" style="width: 6%">搜索</el-button>
        <el-button type="primary" plain style="width: 6%">重置</el-button>
        <el-button type="primary" :loading="loading" @click="handleAssemblySynchronousData" plain style="width: 6%">测试库同步</el-button>
      </el-form-item>
    </el-header>
    <el-main height="85%" style="padding: 4px">
      <el-form-item style="height: 5%">
        <el-button type="primary" plain style="width: 6%;">导出</el-button>
      </el-form-item>
      <el-table :data="tableData" style="width: 100%;height: 77%;">
        <el-table-column type="index" :index="tableData.index" label="序号" width="60" />
        <el-table-column prop="code" label="物料番号" width="150" />
        <el-table-column prop="cnt1" label="物料名称" width="120" />
        <el-table-column prop="date" label="楼棟" width="150" />
        <el-table-column prop="cnt3" label="楼层" width="120" />
        <el-table-column prop="cnt3" label="重量(T)" width="120" />
        <el-table-column prop="cnt3" label="UNIT数(个)" width="120" />
        <el-table-column prop="cnt3" label="面积(㎡)" width="120" />
        <el-table-column prop="cnt3" label="加工进度" width="120" />
        <el-table-column prop="cnt3" label="涂装进度" width="120" />
        <el-table-column prop="cnt3" label="组立进度" width="120" />
        <el-table-column prop="cnt3" label="出荷进度" width="120" />
        <el-table-column prop="cnt3" label="展开结束日" width="120" />
        <el-table-column prop="cnt3" label="切断工程" width="120" >
          <el-table-column prop="cnt3" label="加工结束日" width="120" />
          <el-table-column prop="cnt3" label="当月重量(T)" width="120" />
          <el-table-column prop="cnt3" label="当月面积(㎡)" width="120" />
          <el-table-column prop="cnt3" label="已生产" width="120" />
        </el-table-column>
        <el-table-column prop="cnt3" label="涂装工程" width="120" >
          <el-table-column prop="cnt3" label="涂装结束日" width="120" />
          <el-table-column prop="cnt3" label="当月重量(T)" width="120" />
          <el-table-column prop="cnt3" label="当月面积(㎡)" width="120" />
          <el-table-column prop="cnt3" label="已生产" width="120" />
        </el-table-column>
        <el-table-column prop="cnt3" label="组立工程" width="120" >
          <el-table-column prop="cnt3" label="组立开始日" width="120" />
          <el-table-column prop="cnt3" label="当月数量(个)" width="120" />
          <el-table-column prop="cnt3" label="当月面积(㎡)" width="120" />
          <el-table-column prop="cnt3" label="已生产" width="120" />
        </el-table-column>
        <el-table-column prop="cnt3" label="出荷" width="120" >
          <el-table-column prop="cnt3" label="出荷日期" width="120" />
          <el-table-column prop="cnt3" label="当月重量(T)" width="120" />
          <el-table-column prop="cnt3" label="当月面积(㎡)" width="120" />
          <el-table-column prop="cnt3" label="已生产" width="120" />
        </el-table-column>
        <el-table-column prop="remark" label="搬入" />
      </el-table>
      <div class="pageStyle">
        <el-pagination style="margin-right: 13px" background layout="total, prev, pager, next" :total="total" :current-page="pageNo" @current-change="currentCheckChange" :page-size="10"></el-pagination>
      </div>
    </el-main>

  </el-container>
</div>
</template>

<script>
export default {
  name: "MonthlyAchievements",
  data() {
    return {
      thing: '',
      things: [
        {
          id: '1',
          label: '物件名1'
        },
        {
          id: '2',
          label: '物件名2'
        }
      ],
      floor: '',
      floors: [
        {
        id: '1',
        label: '楼棟1'
        },
        {
          id: '2',
          label: '楼棟2'
        }
        ],
      building: '',
      buildings: [
        {
          id: '1',
          label: '楼层1'
        },
        {
          id: '2',
          label: '楼层2'
        }
      ],
      day: '',
      tableData: [
        {
          code: '257MB1001',
          cnt1: '1000',
          date:'12-01',
          cnt3: '1000',
          remark: 'cs'
        },
      ],
      total: 0,
      pageNo:1,
      loading:false
    }
  },methods: {
    currentCheckChange(pageNo) {
      this.pageNo=pageNo
    },
    handleAssemblySynchronousData() {
      this.loading = true;
      this.$axios.post('mfg/assemblyProduction/handleAssemblySynchronousData').then(response => {
        this.loading = false;
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error(res.message);
        }

        return this.$message.success("数据同步成功");
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    }
  },created() {

  }
}
</script>

<style scoped>
.border {
  border:rgb(216, 220, 230) 1px solid;
}

.el-select {
  margin-right: 10px;
}

.pageStyle{
  width: 100%;
  display: flex;
  justify-content:flex-end;
  margin: 20px 0
}

.el-table :deep(.cell) {
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-all;
  line-height: 23px;
  padding: 0 12px;
  text-align: center;
}

</style>